import { STALE_TIME_RESOURCES } from "@impero-com/common/utils/query_client";

import { useGetCurrencies } from "api/generated/currencies/currencies";

interface UseOrganizationCurrenciesQueryOptions {
    enabled?: boolean;
}

/** Reads the currencies the organization has enabled. */
export const useOrganizationCurrenciesQuery = ({
    enabled = true,
}: UseOrganizationCurrenciesQueryOptions = {}) =>
    useGetCurrencies({
        query: {
            enabled,
            select: (response) => response.data,
            staleTime: STALE_TIME_RESOURCES,
        },
    });
